/**
 * Home - Dynamic Homepage component
 * Dynamic homepage with personalized feed, trending content, and real-time updates
 * Responsive design with mobile-first approach and dynamic content sections
 */

import { useEffect } from 'react';
import OldHomePage from './OldHomePage';
import HomeSimple from './Home.simple';
import { analyticsService } from '../services/analyticsService';

// Toggle between static and simple homepage
const staticHomePage = false; // Set to false for trending feed

export default function Home() {
    // Track homepage view
    useEffect(() => {
        analyticsService.trackPageView('/', 'Homepage');
    }, []);

    return staticHomePage ? <OldHomePage /> : <HomeSimple />;
}